import { Directive, AfterContentInit, OnDestroy, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { RemoteControlSessionService } from './session.service';

@Directive({
  selector: '[app-remote-control-canvas-directive]'
})
export class CanvasDirectiveDirective implements AfterContentInit {

    constructor(
        @Inject(DOCUMENT) private document: Document,
        private sessionService: RemoteControlSessionService
    ) { }

    public ngAfterContentInit(): void {
        // Because new UI does not have direct access to canvas element under remote-control-canvas implemented in Angular1
        // When this component is moved to Angular6 we can target canvas element by reference and using ViewChild
        // or tag canvas element directly with this directive
        // For now we have to resort to DOM queries
        const rcCanvas = this.document.getElementById('rc_canvas') as HTMLCanvasElement;
        rcCanvas.addEventListener('mousedown', this.onCanvasMouseDown);
    }

    private onCanvasMouseDown = () => {
        this.sessionService.onCanvasMouseDown();
    };
}
